import React, { Component } from "react";
import _ from "lodash";
import { Input, Form } from "antd";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

const { TextArea } = Input;

class CommentInput extends Component {
    handleInputChange = (e) => {
        this.props.setState({ tipsComment: e.target.value });
    };

    getValue = () => {
        return this.props.comment;
    };

    getLabel = () => {
        return this.props.intl.formatMessage({ id: "comment" });
    };

    render() {
        return (
            <div>
                <Form.Item label={this.getLabel()} {...this.props.form}>
                    <TextArea rows={4} placeholder={this.getLabel()} onChange={(e) => this.handleInputChange(e)} />
                </Form.Item>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    lan: _.get(state, "setting.lan", "en"),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CommentInput));
